import { AbstractHook } from '@hooks/abstraction';
import { ProfileResponse } from '../services/responses/profile.response';
import { ProfileService } from '../services/profile.service';

export class ProfileHook extends AbstractHook<ProfileResponse, ProfileService> {}
